import { render, staticRenderFns } from "./sales-orders-dashboard.vue?vue&type=template&id=4df51cb7&scoped=true&"
import script from "./sales-orders-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./sales-orders-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./sales-orders-dashboard.vue?vue&type=style&index=0&id=4df51cb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df51cb7",
  null
  
)

export default component.exports